"use strict";
// Copyright © Veeam Software Group GmbH
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledMatrixBaseCell = void 0;
const styled_components_1 = __importStar(require("styled-components"));
const constants_1 = require("../../helpers/constants");
const helpers_1 = require("../../../helpers");
const Icon_1 = require("../../../Icon");
exports.StyledMatrixBaseCell = styled_components_1.default.div `
    vertical-align: middle;
    box-sizing: border-box;
    margin: ${constants_1.CELL_STYLE_CONFIG.main.margin}px ${constants_1.CELL_STYLE_CONFIG.main.margin}px 0 0;
    height: ${constants_1.CELL_STYLE_CONFIG.main.height}px;
    display: inline-flex;
    align-items: center;
    position: relative;
    color: ${(props) => props.theme.colorTextMain};

    ${({ status, theme }) => {
    if (status === constants_1.STATUS_CELL.UNSELECTED) {
        return (0, styled_components_1.css) `
                background-color: ${theme.colorBackgroundDisabled};
            `;
    }
    if (status === constants_1.STATUS_CELL.UNSELECT_HOVER) {
        return (0, styled_components_1.css) `
                background-color: ${theme.colorBackgroundNeutralLight};
            `;
    }
    if (status === constants_1.STATUS_CELL.SELECTED) {
        return (0, styled_components_1.css) `
                background-color: ${theme.colorHighlightDark};
            `;
    }
    if (status === constants_1.STATUS_CELL.SELECT_HOVER) {
        return (0, styled_components_1.css) `
                background-color: ${theme.colorHighlightLight};
            `;
    }
    return (0, styled_components_1.css) `
            background-color: transparent;
        `; // is STATUS_CELL.DISABLED
}}

    ${({ isDayCaption }) => isDayCaption &&
    (0, styled_components_1.css) `
            padding-left: ${helpers_1.SPACING_S};
            padding-right: ${helpers_1.SPACING_L};
            width: 100%;
        `}

    ${({ isDayCaption, indexDay }) => isDayCaption &&
    indexDay >= 0 &&
    (0, styled_components_1.css) `
            &:after {
                box-sizing: border-box;
                width: 100%;
                height: ${constants_1.LEFT_POSITION_DAY_CAPTION}px;
                display: grid;

                position: absolute;
                left: 0;
                bottom: -${constants_1.LEFT_POSITION_DAY_CAPTION - 1}px;

                content: '';
            }
        `}

    ${({ isDayCaption }) => !isDayCaption &&
    (0, styled_components_1.css) `
            width: ${constants_1.CELL_STYLE_CONFIG.main.width}px;
        `}

    ${({ isDemo, indexDay, iconType, indexHour, theme }) => !isDemo &&
    (indexDay === -1 || iconType) &&
    (0, styled_components_1.css) `
            &:after {
                box-sizing: border-box;
                width: ${constants_1.CELL_STYLE_CONFIG.main.width}px;
                height: ${constants_1.CELL_STYLE_CONFIG.main.height}px;

                align-content: center;
                text-align: center;
                display: grid;
                z-index: 1;

                font-weight: ${(indexHour + 1) % 2 === 0 ? 700 : 400};
                color: ${(indexHour + 1) % 2 === 0
        ? theme.colorTextMain
        : theme.colorTextSecondary};
                position: absolute;
                line-height: ${constants_1.CELL_STYLE_CONFIG.main.height}px;
                top: 0;
                right: -${constants_1.LEFT_POSITION_DAY_CAPTION}px;
            }
        `}

    ${({ indexDay, text }) => indexDay === -1 &&
    (0, styled_components_1.css) `
            &:after {
                content: '${text}';
            }
        `}

    ${({ iconType }) => iconType &&
    (0, styled_components_1.css) `
            height: ${constants_1.CELL_STYLE_CONFIG.hourDescription.height}px;
            margin-top: ${constants_1.CELL_STYLE_CONFIG.hourDescription.marginTop}px;

            ${Icon_1.Icon.selector} {
                position: absolute;
                top: 0;
                right: -${constants_1.LEFT_POSITION_DAY_CAPTION}px;
            }
        `}

    ${({ status, isDrawnLink, indexDay, theme }) => status === constants_1.STATUS_CELL.UNSELECT_HOVER &&
    isDrawnLink &&
    indexDay === -1 &&
    (0, styled_components_1.css) `
            &:after {
                background-color: ${theme.colorBackgroundNeutralLight};
            }
        `}

    ${({ status, isDrawnLink, indexDay, theme }) => status === constants_1.STATUS_CELL.SELECT_HOVER &&
    isDrawnLink &&
    indexDay === -1 &&
    (0, styled_components_1.css) `
            &:after {
                background-color: ${theme.colorHighlightLight};
            }
        `}

    ${({ status, isDrawnLink, isDayCaption, theme }) => status === constants_1.STATUS_CELL.UNSELECT_HOVER &&
    isDrawnLink &&
    isDayCaption &&
    (0, styled_components_1.css) `
            &:after {
                background-color: ${theme.colorBackgroundNeutralLight};
            }
        `}

    ${({ status, isDrawnLink, isDayCaption, theme }) => status === constants_1.STATUS_CELL.SELECT_HOVER &&
    isDrawnLink &&
    isDayCaption &&
    (0, styled_components_1.css) `
            &:after {
                background-color: ${theme.colorHighlightLight};
            }
        `}

    ${({ isLong, theme }) => isLong &&
    (0, styled_components_1.css) `
            width: ${constants_1.BIG_WIDTH_CELL}px;
            display: grid;
            text-align: center;
            align-content: center;
            color: ${theme.colorTextSecondary};
        `}

    ${({ indexDay }) => indexDay < -1 &&
    (0, styled_components_1.css) `
            margin-top: 0;
            height: ${helpers_1.SPACING_XL};
        `}

    ${({ isDemo }) => isDemo &&
    (0, styled_components_1.css) `
            margin: 0;
        `}

    ${({ indexHour }) => indexHour === 23 &&
    (0, styled_components_1.css) `
            margin-right: ${constants_1.MARGIN_RIGHT_LAST_MAIN_CELL}px;
        `}
`;
//# sourceMappingURL=MatrixBaseCell.styles.js.map